import React from "react";
import styles from "./HeaderComponent.module.css";
import { useT, useLocale } from "../../i18n";

const PHONE_DISPLAY = "(480) 282-0569";
const PHONE_TEL = "+14802820569";

const HeaderComponent = () => {
  const t = useT().header;
  const locale = useLocale();
  const home = locale === "es" ? "/es" : "/";

  return (
    <header className={styles.header}>
      <a href={home} className={styles.logoLink} aria-label="Exhale Software Solutions, home">
        <img
          src="/Exhale.Daniel.Ray.Rangel.png"
          alt=""
          className={styles.logoImage}
        />
        <span className={styles.lockup}>
          {/* <span className={styles.wordmark}>Exhale</span> */}
          <span className={styles.tagline}>{t.tagline}</span>
        </span>
      </a>

      <nav className={styles.lang} aria-label="Language">
        <a
          href="/"
          className={`${styles.langLink} ${locale === "en" ? styles.langActive : ""}`}
        >
          EN
        </a>
        <span className={styles.langSep} aria-hidden="true">/</span>
        <a
          href="/es"
          className={`${styles.langLink} ${locale === "es" ? styles.langActive : ""}`}
        >
          ES
        </a>
      </nav>

      <div className={styles.right}>
        <a href={`tel:${PHONE_TEL}`} className={styles.callBtn}>
          <svg className={styles.phoneIcon} viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.4 0 .8-.3 1l-2.2 2.2z" />
          </svg>
          <span className={styles.callText}>{PHONE_DISPLAY}</span>
        </a>
      </div>
    </header>
  );
};

export default HeaderComponent;
